import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  &lt;b&gt;UUS!&lt;/b&gt; Leia oma mööbel sõnadeta otsinguga

  <span style="color:#85c1dc;">**FI:**</span>
  &lt;b&gt;UUSI!&lt;/b&gt; Etsi kaluste ilman sanoja

  <span style="color:#85c1dc;">**RU:**</span>
  Найди свою мебель с помощью бессловесного поиска
*/
/* @__NO_SIDE_EFFECTS__ */
const m1475 = msg(
  mf`<b>UUS!</b> Leia oma mööbel sõnadeta otsinguga`,
  mf`<b>UUSI!</b> Etsi kaluste ilman sanoja`,
  mf`Найди свою мебель с помощью бессловесного поиска`,
)

export { m1475 as 'w.module.try_new_search.title' }